export const GET_RESE_STORE_TABLE_DATA = {
    INIT: 'GET_RESE_STORE_TABLE_DATA_INIT',
    SUCCESS: 'GET_RESE_STORE_TABLE_DATA_SUCCESS',
    ERROR: 'GET_RESE_STORE_TABLE_DATA_ERROR'
}

export const GET_RESE_STORE_TABLE_DIVISION = {
    INIT: 'GET_RESE_STORE_TABLE_DIVISION_INIT',
    SUCCESS: 'GET_RESE_STORE_TABLE_DIVISION_SUCCESS',
    ERROR: 'GET_RESE_STORE_TABLE_DIVISION_ERROR'
}

export const GET_RESE_STORE_TABLE_BANNER = {
    INIT: 'GET_RESE_STORE_TABLE_BANNER_INIT',
    SUCCESS: 'GET_RESE_STORE_TABLE_BANNER_SUCCESS',
    ERROR: 'GET_RESE_STORE_TABLE_BANNER_ERROR'
}

export const GET_RESE_STORE_TABLE_CITY = {
    INIT: 'GET_RESE_STORE_TABLE_CITY_INIT',
    SUCCESS: 'GET_RESE_STORE_TABLE_CITY_SUCCESS',
    ERROR: 'GET_RESE_STORE_TABLE_CITY_ERROR'
}

export const GET_RESE_STORE_TABLE_STATE = {
    INIT: 'GET_RESE_STORE_TABLE_STATE_INIT',
    SUCCESS: 'GET_RESE_STORE_TABLE_STATE_SUCCESS',
    ERROR: 'GET_RESE_STORE_TABLE_STATE_ERROR'
}

export const GET_RESE_STORE_TABLE_STATUS = {
    INIT: 'GET_RESE_STORE_TABLE_STATUS_INIT',
    SUCCESS: 'GET_RESE_STORE_TABLE_STATUS_SUCCESS',
    ERROR: 'GET_RESE_STORE_TABLE_STATUS_ERROR'
}

export const UPDATE_RESE_STORE_TABLE_DATA = {
    INIT: 'UPDATE_RESE_STORE_TABLE_DATA_INIT',
    SUCCESS: 'UPDATE_RESE_STORE_TABLE_DATA_SUCCESS',
    ERROR: 'UPDATE_RESE_STORE_TABLE_DATA_ERROR'
}

